export default __webpack_public_path__ + "static/media/cheese.2491230d.png";